import axios from "axios";
import { useRef, useState, useEffect } from "react";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as FileIcon } from "monoff-web-design-system/src/img/icon/24/File, Fill=True.svg";
import { ReactComponent as ExclamationIcon } from "monoff-web-design-system/src/img/icon/24/Exclamation mark, Fill=True.svg";
import AgreePesonalInfo from "../../components/AgreePersonalInfo/AgreePesonalInfo";
import styles from "./InputApply.module.scss";

import Modal from "../../common/Modal/Modal";

export default function InputApply({ isDarkMode, width }) {
  const [name, setName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [isAgree, setIsAgree] = useState(false);
  const [numberAlertMessage, setNumberAlertMessage] = useState("");
  const [birthdayAlertMessage, setBirthdayAlertMessage] = useState("");
  const [emailAlertMessage, setEamilAlertMessage] = useState("");
  const [applyFileInfo, setApplyFileInfo] = useState([]);
  const [portfolioFileInfo, setPortfolioInfo] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputAlerMessage, setInputMessage] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const job = location?.state?.data;
  useEffect(() => {
    if (!job) {
      navigate("/position");
    }
  }, [job, location]);
  let regEmail =
    /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
  let regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
  let regBirthday =
    /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;

  useEffect(() => {
    if (isModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isModal]);
  const form = useRef();
  const onChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "birthday":
        setBirthday(value);
        break;
      case "phoneNumber":
        setPhoneNumber(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "link":
        setLink(value);
        break;
      case "agree":
        setIsAgree(true);
        break;
      default:
    }
  };
  useEffect(() => {
    if (!regPhone.test(phoneNumber)) {
      setNumberAlertMessage("올바른 번호를 입력해주세요");
    } else {
      setNumberAlertMessage("");
    }
  }, [phoneNumber, regPhone]);
  useEffect(() => {
    if (!regEmail.test(email)) {
      setEamilAlertMessage("올바른 이메일를 입력해주세요");
    } else {
      setEamilAlertMessage("");
    }
  }, [email, regEmail]);
  useEffect(() => {
    if (!regBirthday.test(birthday)) {
      setBirthdayAlertMessage("올바른 생년월일을 입력해주세요");
    } else {
      setBirthdayAlertMessage("");
    }
  }, [birthday, regBirthday]);
  useEffect(() => {
    if (phoneNumber.length === 11) {
      setPhoneNumber(phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3"));
    }
    if (phoneNumber.length === 13) {
      setPhoneNumber(
        phoneNumber
          .replace(/-/g, "")
          .replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")
      );
    }
  }, [phoneNumber]);
  useEffect(() => {
    if (birthday.length === 8) {
      setBirthday(
        birthday.replace(/-/g, "").replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
      );
    }
  }, [birthday]);

  useEffect(() => {
    if (applyFileInfo?.target?.files[0]) {
      if (
        applyFileInfo?.target?.files[0] &&
        !portfolioFileInfo?.target?.files[0]
      ) {
        console.log(
          (applyFileInfo?.target?.files[0]?.size / 1024 / 1024).toFixed(1)
        );
      } else {
        console.log(
          (
            (applyFileInfo?.target?.files[0]?.size +
              portfolioFileInfo?.target?.files[0]?.size) /
            1024 /
            1024
          ).toFixed(1)
        );
      }
    } else {
      return;
    }
  }, [applyFileInfo?.target?.files, portfolioFileInfo?.target?.files]);
  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();
    formData.append(email, applyFileInfo?.target?.files[0]);
    if (portfolioFileInfo?.target?.files[0])
      formData.append(email, portfolioFileInfo?.target?.files[0]);
    try {
      const response = await axios(
        `https://server.mondayoff.me/email/attachment/${email}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        }
      );
      if (response.data.message) {
        axios(`https://server.mondayoff.me/email/info`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            duty: job.duty,
            name,
            phoneNumber,
            birthday,
            email,
            link,
            file1: response.data.fileInfo[0].filename,
            file2: response.data.fileInfo[1]
              ? response.data.fileInfo[1].filename
              : null,
          },
        }).then((d) => d);
      }
      if (!response.data.message) {
        throw new Error(response.statusText);
      }
    } catch (error) {
      alert("Failed to upload videos: " + error.message);
    } finally {
      setIsLoading(false);
      setIsModal(false);
      navigate("/position/submission", { replace: true, state: job });
    }
  };

  const onClickModal = () => {
    if (name === "") {
      setIsToast(true);
      setInputMessage(
        job?.lo === "en"
          ? "Please enter your Name"
          : "이름은 필수 입력항목입니다."
      );
      setTimeout(() => {
        setIsToast(false);
      }, 2000);
    } else if (birthday === "") {
      setIsToast(true);
      setInputMessage(
        job?.lo === "en"
          ? "Please enter your Date of Birth"
          : "생년월일은 필수 입력항목입니다."
      );
      setTimeout(() => {
        setIsToast(false);
      }, 2000);
    } else if (phoneNumber === "") {
      setIsToast(true);
      setInputMessage(
        job?.lo === "en"
          ? "Please enter your Contact Number"
          : "전화 번호는 필수 입력항목입니다."
      );
      setTimeout(() => {
        setIsToast(false);
      }, 2000);
    } else if (email === "") {
      setIsToast(true);
      setInputMessage(
        job?.lo === "en"
          ? "Please enter your E-mail"
          : "이메일은 필수 입력항목입니다."
      );
      setTimeout(() => {
        setIsToast(false);
      }, 2000);
    } else if (!applyFileInfo?.target?.files?.length) {
      setIsToast(true);
      setInputMessage(
        job?.lo === "en" ? "Please upload your resume" : "이력서를 등록해주세요"
      );
      setTimeout(() => {
        setIsToast(false);
      }, 2000);
    } else if (!isAgree) {
      setIsToast(true);
      setInputMessage(
        job?.lo === "en"
          ? "You must agree to our privacy policy to apply."
          : "동의를 해주세요"
      );
      setTimeout(() => {
        setIsToast(false);
      }, 2000);
    } else {
      window.scrollTo(0, 0);
      setIsModal(true);
    }
  };

  const onUploadApplyClick = (e) => {
    let myInput = document.getElementById("apply");
    return myInput.click();
  };

  const onUploadPortfolioClick = (e) => {
    e.preventDefault();
    let myInput = document.getElementById("portfolio");
    return myInput.click();
  };
  return (
    <div className={styles.container}>
      {isModal && (
        <Modal
          job={job}
          name={name}
          email={email}
          applyName={applyFileInfo?.target?.files[0]?.name}
          portfolioName={portfolioFileInfo?.target?.files[0]?.name}
          link={link}
          phoneNumber={phoneNumber}
          setIsModal={setIsModal}
          onSubmit={onSubmit}
          isDarkMode={isDarkMode}
          isLoading={isLoading}
          width={width}
        />
      )}

      <div className={styles.topContainer}>
        <section className={styles.duty_container}>
          <div className={styles.duty}>
            <p
              className={classNames({
                "title-kr-L": width > 768 ? true : false,
                "label-kr-L": width < 768 ? true : false,
              })}
            >
              {job?.team}
            </p>
            <p
              className={classNames({
                "display-kr-L": width > 768 ? true : false,
                "title-kr-XL": width < 768 ? true : false,
              })}
            >
              {job?.duty}
            </p>
          </div>
        </section>

        <div className={styles.topBackground}>
          <img
            src={job.img}
            alt=""
            className={
              job.position === "개발" ? styles.selectImg : styles.defaultImg
            }
          />
          <div className={styles.img_filter} />
        </div>
      </div>

      <div className={styles.apply_container}>
        <section className={styles.apply_area}>
          <p
            className={classNames(styles.apply_title, {
              "display-kr-L": width > 768 ? true : false,
              "display-kr-M": width < 768 ? true : false,
            })}
          >
            {job?.lo === "en" ? "Application Form" : "지원서 작성하기"}
          </p>

          <form
            ref={form}
            encType="multipart/form-data"
            className={
              !isDarkMode
                ? styles.apply_form_container
                : styles.dark_apply_form_container
            }
          >
            <section className={styles.name}>
              <span className={styles.name_label}>
                <p
                  className={classNames({
                    "label-kr-S": true,
                  })}
                >
                  {job?.lo === "en" ? "Name" : "이름"}
                </p>{" "}
                <p>*</p>
              </span>
              <input
                className={classNames({
                  "single-input-box": true,
                })}
                onChange={onChange}
                type="text"
                name="name"
                placeholder={
                  job?.lo === "en"
                    ? "Please enter your name"
                    : "이름을 입력해주세요."
                }
              />
            </section>

            <section className={styles.birthday}>
              <span className={styles.birthday_label}>
                <p
                  className={classNames({
                    "label-kr-S": true,
                  })}
                  data-content={
                    regBirthday.test(birthday) || !birthday ? "" : "warning"
                  }
                >
                  {job?.lo === "en" ? "Date of Birth" : "생년월일"}
                </p>{" "}
                <p>*</p>
              </span>
              <input
                className={classNames({
                  "single-input-box": true,
                })}
                data-content={
                  regBirthday.test(birthday) || !birthday ? "" : "warning"
                }
                onChange={onChange}
                type="text"
                name="birthday"
                value={birthday}
                pattern="[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}"
                placeholder={
                  job?.lo === "en"
                    ? "Please enter your date of birth (ex : 19990807)"
                    : "생년월일을 입력해주세요. (예시: 19990807)"
                }
                required
              />

              {birthday &&
                birthdayAlertMessage &&
                (job?.lo === "en" ? (
                  <p
                    className={classNames(styles.alert_message, {
                      "body-kr-S": true,
                    })}
                  >
                    This must be a valid date of birth.
                  </p>
                ) : (
                  <p
                    className={classNames(styles.alert_message, {
                      "body-kr-S": true,
                    })}
                  >
                    {birthdayAlertMessage}
                  </p>
                ))}
            </section>
            <section className={styles.number}>
              <span className={styles.number_label}>
                <p
                  className={classNames({
                    "label-kr-S": true,
                  })}
                  data-content={
                    regPhone.test(phoneNumber) || !phoneNumber ? "" : "warning"
                  }
                >
                  {job?.lo === "en" ? "Contact information" : "전화번호"}{" "}
                </p>
                <p>*</p>
              </span>
              <input
                className={classNames({
                  "single-input-box": true,
                })}
                data-content={
                  regPhone.test(phoneNumber) || !phoneNumber ? "" : "warning"
                }
                type="tel"
                name="phoneNumber"
                placeholder={
                  job?.lo === "en"
                    ? "Please enter your cellphone number"
                    : "전화 번호를 입력해주세요."
                }
                onChange={onChange}
                value={phoneNumber}
                pattern="[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}"
                maxLength="13"
                required
              />

              {phoneNumber &&
                numberAlertMessage &&
                (job?.lo === "en" ? (
                  <p
                    className={classNames(styles.alert_message, {
                      "body-kr-S": true,
                    })}
                  >
                    This must be a valid cellphone number.
                  </p>
                ) : (
                  <p
                    className={classNames(styles.alert_message, {
                      "body-kr-S": true,
                    })}
                  >
                    {numberAlertMessage}
                  </p>
                ))}
            </section>
            <section className={styles.email}>
              <span className={styles.email_label}>
                <p
                  className={classNames({
                    "label-kr-S": true,
                  })}
                  data-content={regEmail.test(email) || !email ? "" : "warning"}
                >
                  {job?.lo === "en" ? "E-mail" : "이메일"}
                </p>{" "}
                <p>*</p>
              </span>
              <input
                className={classNames({
                  "single-input-box": true,
                })}
                data-content={regEmail.test(email) || !email ? "" : "warning"}
                type="email"
                name="email"
                placeholder={
                  job?.lo === "en"
                    ? "Please enter your e-mail"
                    : "이메일 주소를 입력해주세요."
                }
                onChange={onChange}
              />

              {email &&
                emailAlertMessage &&
                (job?.lo === "en" ? (
                  <p
                    className={classNames(styles.alert_message, {
                      "body-kr-S": true,
                    })}
                  >
                    This must be a valid email.
                  </p>
                ) : (
                  <p
                    className={classNames(styles.alert_message, {
                      "body-kr-S": true,
                    })}
                  >
                    {emailAlertMessage}
                  </p>
                ))}
            </section>
            <section className={styles.applyBox}>
              <span className={styles.applyBox_label}>
                <p
                  className={classNames({
                    "label-kr-S": true,
                  })}
                >
                  {job?.lo === "en" ? "Resume, Cover letter" : "이력서"}
                </p>
                <p>*</p>
              </span>
              <div
                className={classNames(styles.applyBox_apply, {
                  "both-icon-input-box": true,
                })}
              >
                <FileIcon />
                <p
                  className={classNames(styles.applyBox_placeholder, {
                    "body-kr-M": true,
                  })}
                >
                  {job?.lo === "en"
                    ? applyFileInfo?.target?.files?.length
                      ? applyFileInfo?.target?.files[0]?.name
                      : "Upload a file"
                    : applyFileInfo?.target?.files?.length
                    ? applyFileInfo?.target?.files[0]?.name
                    : "파일 첨부하기"}
                </p>
                <label htmlFor={styles.applyBox_button}>
                  <div
                    className={classNames(styles.applyBox_button, {
                      "white-line-small-button": true,
                      "label-kr-S": true,
                    })}
                    onClick={() => onUploadApplyClick()}
                  >
                    Upload File
                  </div>
                  <input
                    type="file"
                    id="apply"
                    accept="application/pdf"
                    onChange={setApplyFileInfo}
                  />
                </label>
              </div>

              {job?.lo === "en" ? (
                <p
                  className={classNames(styles.applyBox_alert_message, {
                    "body-kr-M": true,
                  })}
                >
                  • Upload a single PDF File. File type must be in PDF format
                </p>
              ) : (
                <>
                  <p
                    className={classNames(styles.applyBox_alert_message, {
                      "body-kr-M": true,
                    })}
                  >
                    • 이력서는 자유양식으로 PDF 파일로 첨부해주세요.
                  </p>
                  <p
                    className={classNames(styles.applyBox_alert_message, {
                      "body-kr-M": true,
                    })}
                  >
                    • 개인정보(주민등록번호, 가족관계, 신체사항 등)는 요구하지
                    않습니다.
                  </p>
                </>
              )}
            </section>

            <section className={styles.portfolioBox}>
              <p
                className={classNames({
                  "label-kr-S": true,
                })}
              >
                {job?.lo === "en"
                  ? "Portfolio(Optional)"
                  : "포트폴리오 (선택사항)"}
              </p>
              <div
                className={classNames(styles.portfolioBox_portfolio, {
                  "both-icon-input-box": true,
                })}
              >
                <FileIcon />

                <p
                  className={classNames(styles.portfolioBox_placeholder, {
                    "body-kr-M": true,
                  })}
                >
                  {job?.lo === "en"
                    ? portfolioFileInfo?.target?.files?.length
                      ? portfolioFileInfo?.target?.files[0]?.name
                      : "Upload a file"
                    : portfolioFileInfo?.target?.files?.length
                    ? portfolioFileInfo?.target?.files[0]?.name
                    : "파일 첨부하기"}
                </p>
                <label htmlFor="portfolio">
                  <div
                    className={classNames(styles.portfolioBox_button, {
                      "white-line-small-button": true,
                      "label-kr-S": true,
                    })}
                    onClick={() => onUploadPortfolioClick()}
                  >
                    Upload File
                  </div>
                  <input
                    type="file"
                    id="portfolio"
                    accept="application/pdf"
                    onChange={setPortfolioInfo}
                  />
                </label>
              </div>

              {job?.lo === "en" ? (
                <>
                  <div
                    className={classNames(styles.portfolioBox_alert_message, {
                      "body-kr-M": true,
                    })}
                  >
                    • File size must not exceed 20MB
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={classNames(styles.portfolioBox_alert_message, {
                      "body-kr-M": true,
                    })}
                  >
                    • 포트폴리오를 필수로 제출하셔야 하는 포지션은 직무 별
                    모집요강을 참고해주세요.
                  </div>
                  <div
                    className={classNames(styles.portfolioBox_alert_message, {
                      "body-kr-M": true,
                    })}
                  >
                    • 파일의 크기는 최대 20MB를 넘지 않아야 합니다.
                  </div>
                </>
              )}
            </section>
            <section className={styles.linkBox}>
              <p
                className={classNames({
                  "label-kr-S": true,
                })}
              >
                {job?.lo === "en"
                  ? "Additional Link (Optional)"
                  : "링크 (선택사항)"}
              </p>
              <input
                className={classNames({
                  "single-input-box": true,
                })}
                type="url"
                name="link"
                placeholder="https://"
                onChange={onChange}
              />
              <p className={classNames({ "body-kr-M": true })}>
                •{" "}
                {job?.lo === "en"
                  ? "If you have a portfolio or other link you would like to share, please attach."
                  : "포트폴리오나 그 외에 자신을 드러낼 수 있는 링크가 있다면 입력해주세요."}
              </p>
            </section>
            <section className={styles.agreeBox}>
              <span className={styles.agreeBox_label}>
                <p className={classNames({ "label-kr-S": true })}>
                  {job?.lo === "en"
                    ? "Applicant Privacy Statement"
                    : "개인 정보 수집 및 이용 동의"}
                </p>
                <p>*</p>
              </span>
              <AgreePesonalInfo isDarkMode={isDarkMode} job={job} />

              <div className={styles.agreeCheckbox}>
                <label className={styles.agreeCheckbox_text}>
                  <input type="checkbox" name="agree" onChange={onChange} />
                  <p className={classNames({ "body-kr-M": true })}>
                    {job?.lo === "en"
                      ? "I hereby confirm that I have read and understood the terms and conditions"
                      : "위 내용을 확인하였으며 동의합니다."}
                  </p>
                </label>
              </div>
              <section className={styles.submit_btn}>
                {/* {isToast && (
                
              )} */}
                <div
                  data-content={isToast ? "visible" : "invisible"}
                  className={styles.agreeCheckbox_alert_message}
                >
                  <ExclamationIcon />
                  <p
                    className={classNames({
                      "label-kr-M": true,
                    })}
                  >
                    {inputAlerMessage}
                  </p>
                </div>
                <button
                  type="button"
                  className={classNames(styles.applySubmit, {
                    "red-large-button": true,
                    "label-kr-M": true,
                  })}
                  onClick={onClickModal}
                >
                  {job?.lo === "en" ? "Submit" : "지원서 제출하기"}
                </button>
              </section>
            </section>

            <div className={styles.dutyhide}>
              <input name="duty" value={`${job?.team} ${job?.duty}`} />
            </div>
          </form>
        </section>
      </div>
    </div>
  );
}
